module.exports = __webpack_public_path__ + "idp-logo-e05a49f350c1b21df391.png";